module.exports = __webpack_public_path__ + "static/img/nda.5cb49f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/nda.png
// module id = S29C
// module chunks = 1